<template>
  <!-- 上搜索框 -->
  <ConfigProvider
    :theme-vars="{
      searchPadding: '2px 0',
    }"
    v-if="![MARKET_TYPE.SEND_PRODUCT, MARKET_TYPE.SEND_ACTIVITY].includes(type)"
  >
    <van-search
      v-if="searchInput.visible"
      v-model="searchText"
      @update:model-value="handleSearchTextChange"
      shape="round"
      :placeholder="searchInput.placeholder"
    />
  </ConfigProvider>
  <!-- 一级导航 -->
  <div class="first-nav">
    <span
      v-for="(item, index) in firstNavList"
      @click="handleFirstNavClick(item, index, $event)"
      :class="`first-nav-item  ${index === state.firstNavActive && 'active'}`"
      :key="item.name"
    >
      {{ item.name }}
    </span>
  </div>
  <!-- 二级导航 -->
  <div v-show="secondNavList.length" class="second-nav">
    <span
      v-for="(item, index) in secondNavList"
      @click="handleSecondNavClick(item, index, $event)"
      :class="`second-nav-item ${index === state.secondNavActive && 'active'}`"
      :key="item.name"
    >
      {{ item.name }}
    </span>
  </div>
  <!--下搜索框-->
  <ConfigProvider
    :theme-vars="{
      searchPadding: '2px 0',
    }"
    v-if="[MARKET_TYPE.SEND_PRODUCT, MARKET_TYPE.SEND_ACTIVITY].includes(type)"
  >
    <van-search
      v-if="searchInput.visible"
      v-model="searchText"
      @update:model-value="handleSearchTextChange"
      shape="round"
      :placeholder="searchInput.placeholder"
    />
  </ConfigProvider>
  <template v-if="loadEnd">
    <!-- 有数据 -->
    <BasePullUpRefresh
      v-if="marketSelectList.length"
      :total="pager.total"
      :data="marketSelectList"
      @loadMore="handleLoadMore"
      id="market-select-scroll-box"
      :className="`market-list-scroll-box
        ${searchInput.visible && 'has-search'}
        ${secondNavList.length && 'has-two-nav'}
        ${isNewsPapaer && 'has-news-papaer'}
      `"
    >
      <template #scroll-list>
        <MarketTemplate
          :type="type"
          :firstSelectItem="firstSelectItem"
          :selectedMarketItems="selectedMarketItems"
          :enabledSelectedMarketList="enabledSelectedMarketList"
          :marketSelectList="marketSelectList"
          :maxSeclectCount="maxSeclectCount"
          :handleMarketItemChecked="handleMarketItemChecked"
        />
      </template>
    </BasePullUpRefresh>

    <!-- 无数据 -->
    <BaseEmpty v-else tips="暂无内容"></BaseEmpty>
  </template>

  <!-- 底部操作区 -->
  <div class="footer-action">
    <div
      @click="toggleSelectedMarketVisible(!visibleSelectMarketItem)"
      :data-jt-sender="setDataJTSender('show-select')"
      class="footer-action-select-count"
    >
      <!-- 选择产品图标 -->
      <i class="cz-iconfont czlist_nor"></i>
      已选（
      <span v-if="!enabledSelectedMarketList?.length">0</span>
      <span v-else :style="{ color: '#004EE3' }">{{ enabledSelectedMarketList?.length }}/{{ maxSeclectCount }}</span>
      ）
    </div>
    <div :data-jt-sender="setDataJTSender('ensure')" class="footer-action-btn" @click="handleCheckedConfirm">完成</div>
  </div>

  <VanPopup
    position="bottom"
    v-model:show="visibleSelectMarketItem"
    @close="toggleSelectedMarketVisible(false)"
    class="select-market-item-modal"
    overlay-class="select-market-item-overlay"
  >
    <h5 class="select-market-item-title one-px">
      <span>当前选择 （{{ enabledSelectedMarketList?.length }}/{{ maxSeclectCount }}）</span>
      <i @click="removeAllSeclectItem">清空</i>
    </h5>
    <div class="select-market-item-box">
      <div class="select-market-item-action one-px" v-for="(item, index) of enabledSelectedMarketList" :key="index">
        <i
          @click="() => removeSelectedItem(item)"
          :class="`cz-iconfont czshanchu select-market-item-icon-close ${item?.disabled ? 'disabled' : ''}`"
        ></i>
        <MarketCard :type="type" :item="item" />
      </div>
    </div>
  </VanPopup>
</template>
<script setup lang="ts">
  import { ref, toRefs, reactive, computed, onMounted, watch, inject } from 'vue';
  import { Popup as VanPopup, Search as VanSearch, ConfigProvider } from 'vant';
  import MarketTemplate from './market-card/template.vue';
  import BaseEmpty from '../base-empty/index.vue';
  import BasePullUpRefresh from '../base-pull-up-refresh/index.vue';
  // import { Loading } from '../base-dialog/index';
  import { formatIncomeRate } from '../../utils';
  import { taskApi, bannerApi, productApi, newsApi, posterApi } from '../../apis';
  import { TMarketItem, TMarketListItem, TMarketNavItem } from '../../types';
  import { MARKET_IFON, MARKET_TYPE } from './contsants';
  import MarketCard from './market-card/index.vue';
  import { Confirm } from '../base-dialog/index';

  const props = defineProps({
    // 营销任务类型
    type: {
      type: String,
      default: MARKET_TYPE.SEND_PRODUCT,
    },
    // 最大可选数量
    maxSeclectCount: {
      type: Number,
      default: 1,
    },
    selectedMarketList: {
      type: Array,
      default: () => [],
    },
    productConfigType: {
      type: Number,
      default: 0,
    },
  });

  let updateProductTypeId = '';
  if (props.type === MARKET_TYPE.SEND_PRODUCT && props.productConfigType) {
    const injected = inject('productConfig') as any;
    updateProductTypeId = injected?.updateProductTypeId;
  }

  const { type } = toRefs(props);
  // 一级导航列表
  const firstNavList = ref<TMarketNavItem[]>([]);
  // 二级导航列表
  const secondNavList = ref<TMarketNavItem[]>([]);
  // 通用的营销选项列表
  const marketSelectList = ref<TMarketListItem[]>([]);

  const isNewsPapaer = computed(
    () => location.href.indexOf('/newsPaperDetail') !== -1 && props.type === MARKET_TYPE.SEND_PRODUCT
  );

  const firstSelectItem = computed(() => {
    return firstNavList.value?.length ? firstNavList.value[state.firstNavActive] : {};
  });

  const enabledSelectedMarketList = computed(() => {
    return state.selectedMarketItems.filter((item: TMarketListItem) => !item.disabled);
  });

  // 显示搜索框的条件
  const searchInput = computed(() => {
    // 选择产品显示搜索框的条件, 产品类型--热门推荐没有搜索功能
    const isProductShowSearch = state.firstNavActive !== 0 && props.type === MARKET_TYPE.SEND_PRODUCT;
    const visible =
      isProductShowSearch ||
      [MARKET_TYPE.SEND_POSTER, MARKET_TYPE.SEND_ACTIVITY, MARKET_TYPE.SEND_ARTICLE].includes(props.type);
    const placeholder = MARKET_IFON[props.type].placeholder || '搜索关键字';
    return { visible, placeholder };
  });

  const state: TLooseObj = reactive({
    // 搜索输入框文字
    searchText: '',
    // 激活的一级导航
    firstNavActive: 0,
    // 激活的二级导航
    secondNavActive: 0,
    // 选中的营销子项
    selectedMarketItems: [],
    // 显示选中项弹窗
    visibleSelectMarketItem: false,
    // 是否加载完成
    loadEnd: false,
    // 产品列表查询参数
    productParams: {
      typeId: '',
    },
    // 海报列表查询参数
    posterParams: {
      classification: '',
    },
    // 活动列表参数
    activityParams: {
      categoryId: '',
    },
    // 文章列表查询参数
    articleParams: {
      tags: '',
      queryType: 0,
    },
    // 朋友圈神器列表查询参数
    momentParams: {
      sceneId: '',
      classifyId: '',
    },
    // 节点关怀列表查询参数
    careParams: {
      typeId: '',
    },
    // 分页参数
    pager: {
      pageNum: 1,
      total: 0,
    },
  });

  const { searchText, pager, loadEnd, selectedMarketItems, visibleSelectMarketItem } = toRefs(state);

  watch(
    () => props.selectedMarketList,
    (val) => {
      state.selectedMarketItems = val;
    },
    {
      immediate: true,
    }
  );

  watch(
    () => state.productParams.typeId,
    (val) => {
      updateProductTypeId && updateProductTypeId(val);
    }
  );

  onMounted(async () => {
    // =======================查询市场营销类任务的导航数据并进行列表初始化===================
    if (props.type === 'SEND_PRODUCT') {
      // 选择产品一级导航
      props.productConfigType !== 2 && (firstNavList.value = [{ id: 1, name: '本周推荐', list: [] }]);
      if (props.productConfigType !== 1) {
        // 选择产品二级导航
        productApi.getProductBusinessList({}).then(({ retdata }) => {
          // console.log(retdata);
          const { privateBusinessList = [], publicBusinessList = [] } = retdata as TLooseObj;
          // 公司业务
          publicBusinessList.length && firstNavList.value.push({ id: 2, name: '公司业务', list: publicBusinessList });
          // 个人业务
          privateBusinessList.length && firstNavList.value.push({ id: 3, name: '个人业务', list: privateBusinessList });
          setProductParams();
        });
      }
      // 产品默认查询的是本周推荐列表--无需分页-无二级导航
      queryMatchTypeList();
    } else if (props.type === MARKET_TYPE.SEND_ACTIVITY) {
      // 选择活动一级导航--全部tab是固定的
      firstNavList.value = [{ id: '', name: '全部', list: [] }];
      bannerApi.getBannerCategoryList(0).then(({ retdata = [] }: TLooseObj) => {
        firstNavList.value = [...firstNavList.value, ...retdata];
      });
      queryMatchTypeList();
    } else if (props.type === MARKET_TYPE.SEND_POSTER) {
      // 选择海报一级导航--全部tab是固定的
      firstNavList.value = [{ id: '', name: '全部', list: [] }];
      posterApi.getPosterTypeList(0).then(({ retdata = [] }: TLooseObj) => {
        firstNavList.value = [...firstNavList.value, ...retdata];
      });
      queryMatchTypeList();
    } else if (props.type === MARKET_TYPE.SEND_ARTICLE) {
      const { retdata = {} }: TLooseObj = await newsApi.getNewsTypeList({});
      const newsTypeList = retdata?.typeList?.map(({ name = '', type = '' }: TLooseObj) => ({ name, id: type }));
      firstNavList.value = newsTypeList || [];
      queryMatchTypeList();
    } else if (props.type === MARKET_TYPE.SEND_FESTIVAL_CARE) {
      // 获取选择节点关怀一级导航数据
      getCareScene();
    } else if (props.type === MARKET_TYPE.SEND_MOMENTS) {
      // 获取选择朋友圈神器一级和二级导航数据
      getMomentsScene();
    }
  });

  // 处理搜索框输入改变
  const handleSearchTextChange = () => {
    // console.log('handleSearchTextChange', state.searchText);
    restQueryParams();
    queryMatchTypeList();
  };

  // 处理加载更多
  const handleLoadMore = () => {
    state.pager.pageNum++;
    queryMatchTypeList(true);
    // console.log('handleLoadMore', state.pager.pageNum,marketSelectList.value?.length, state.pager.total);
  };

  // 查询类型匹配的列表
  const queryMatchTypeList = async (isAppendData = false) => {
    // Loading.show();
    const action: TLooseObj = {
      [MARKET_TYPE.SEND_PRODUCT]: getProductList,
      [MARKET_TYPE.SEND_ACTIVITY]: getActivityList,
      [MARKET_TYPE.SEND_ARTICLE]: getArticleList,
      [MARKET_TYPE.SEND_POSTER]: getPosterList,
      [MARKET_TYPE.SEND_FESTIVAL_CARE]: getCareList,
      [MARKET_TYPE.SEND_MOMENTS]: getMomentList,
    };
    const { list = [], total = 0 } = await action[props.type]?.(state.pager.pageNum);
    state.pager.total = total;
    // console.log(marketSelectList.value, list);
    if (isAppendData) {
      marketSelectList.value = [...marketSelectList.value, ...list];
    } else {
      // 搜索的时候,查询结果太慢,会导致赋值错位,本应清空列表数据,结果被滞后的结果重新赋值,造成逻辑错误
      // 所以只有上拉加载更多的时候,追加数据,其它类型的查询,都是重置列表
      marketSelectList.value = list;
    }
    // Loading.hide();
    state.loadEnd = true;
  };

  const setProductParams = (index = 0) => {
    if (state.firstNavActive === 0 && firstNavList.value[0].id === 1) {
      return;
    }
    const navList = firstNavList.value[index].list || [];
    secondNavList.value = navList;
    // 二级导航为空,不查询
    if (navList.length === 0) {
      return setEmptyPage();
    } else {
      // 二级导航类别初始查询值
      state.productParams.typeId = navList[0].id || '';
    }
  };

  // 一级导航点击处理
  const handleFirstNavClick = async (item: TMarketNavItem, index: number, event: MouseEvent) => {
    //  重复点击相同的tab什么也不执行
    if (index === state.firstNavActive) return;
    state.firstNavActive = index;
    state.secondNavActive = 0;
    // state.searchText = '';
    restQueryParams();
    // 让点击的位于容器边缘的tab移动到可视区域
    fixedActiveTabVisual(event, 'first-nav');
    // console.log('handleFirstNavClick',item, index);
    const { type } = props;
    if (type === MARKET_TYPE.SEND_FESTIVAL_CARE) {
      state.careParams.typeId = item.id;
      // console.log('handleFirstNavClick',state.careParams.typeId);
    } else if (type === MARKET_TYPE.SEND_MOMENTS) {
      getMomentsClassify(item.id as number);
    } else if (type === MARKET_TYPE.SEND_PRODUCT) {
      // 本周推荐没有二级导航却需要查询
      if (item.name === '本周推荐') {
        const navList = firstNavList.value[index].list || [];
        secondNavList.value = navList;
        state.productParams.typeId = '';
      } else {
        setProductParams(index);
      }
    } else if (type === MARKET_TYPE.SEND_ACTIVITY) {
      getActivityClassify(item);
    } else if (type === MARKET_TYPE.SEND_ARTICLE) {
      state.articleParams.queryType = item.id;
      state.articleParams.tags = item.name;
    } else if (type === MARKET_TYPE.SEND_POSTER) {
      state.posterParams.classification = item.id;
    }
    if (
      [
        MARKET_TYPE.SEND_PRODUCT,
        MARKET_TYPE.SEND_ACTIVITY,
        MARKET_TYPE.SEND_POSTER,
        MARKET_TYPE.SEND_ARTICLE,
        MARKET_TYPE.SEND_FESTIVAL_CARE,
      ].includes(type)
    ) {
      queryMatchTypeList();
      setTimeout(() => {
        const secondNavDom = document.querySelector('.second-nav') as HTMLDivElement;
        if (secondNavDom) {
          secondNavDom.scrollLeft = 0;
        }
      }, 0);
    }
  };

  // 二级导航点击处理
  const handleSecondNavClick = async (item: TMarketNavItem, index: number, event: MouseEvent) => {
    //  重复点击相同的tab什么也不执行
    if (index === state.secondNavActive) return;
    const { type } = props;
    // console.log('handleSecondNavClick',item, index);
    state.secondNavActive = index;
    restQueryParams();
    // state.searchText = '';
    // 让点击的位于容器边缘的tab移动到可视区域
    fixedActiveTabVisual(event, 'second-nav');

    if (type === MARKET_TYPE.SEND_PRODUCT) {
      state.productParams.typeId = item.id;
    } else if (type === MARKET_TYPE.SEND_MOMENTS) {
      state.momentParams.classifyId = item.id;
    } else if (type === MARKET_TYPE.SEND_ACTIVITY) {
      state.activityParams.typeId = item.id;
    }
    queryMatchTypeList();
  };

  // 处理营销类型子项选择
  const handleMarketItemChecked = (item: TLooseObj, _index: number) => {
    // 禁用
    if (state.selectedMarketItems?.findIndex((i: TLooseObj) => i.disabled && i.id === item.id) > -1) {
      return;
    }
    // 取消选中
    if (state.selectedMarketItems.some((val: TLooseObj) => val.id === item.id)) {
      const _newSelectedMarketItems = state.selectedMarketItems.filter((market: any) => market.id !== item?.id);
      state.selectedMarketItems = _newSelectedMarketItems;
      return;
    }
    // 选中
    if (
      enabledSelectedMarketList.value?.length < props.maxSeclectCount &&
      state.selectedMarketItems.every((val: TLooseObj) => val.id !== item.id)
    ) {
      const { title: name = '', id = '', businessType = '' } = item;
      state.selectedMarketItems.push({ ...item, id, name, businessType });
    }
  };

  const getActivityClassify = (item: TMarketItem) => {
    secondNavList.value =
      item?.typeList?.map((val: TMarketItem) => ({
        // 为了方便取值，统一营销类二级导航的列表字段
        id: val.id,
        name: val.name,
      })) || [];
    if (item?.typeList?.length) {
      secondNavList.value.unshift({ id: '', name: '全部' });
    }
    state.activityParams.categoryId = item.id;
    state.activityParams.typeId = secondNavList.value[0]?.id || '';
  };

  // 获取产品列表
  const getProductList = async (pageNum: number) => {
    let res: TLooseObj = {};
    const { typeId = '' } = state.productParams;
    // state.firstNavActiveIndex=0 说明是本周推荐推荐tab处于高亮状态
    // 本周推荐产品列表查询比较特殊--没有二级导航,没有分页
    if (state.firstNavActive === 0 && firstNavList.value[0].name === '本周推荐') {
      // 获取本周推荐产品列表--不需分页
      res = await productApi.getRecommendProductList({});
    } else {
      res = await productApi.getProductListByTypeId({
        typeId,
        pageNum,
        name: state.searchText,
        pageSize: 20,
      });
    }
    // 解决标签已切换loading展示仍残留问题
    // Loading.hide();
    let { total = 0, list = [] } = res.retdata;
    list = toShowProductList(list);
    // console.log(list);
    return { total, list };
  };

  // 只取展示的产品列表字段
  const toShowProductList = (list = []) => {
    // 理财类的收益率可能有中文,需要处理成html片段
    let showList = formatIncomeRate(list);

    // 产品名称取值逻辑
    const productName = (item: TLooseObj) => {
      const { name = '', version, fundProductSimpleInfo = {} } = item;
      // 基金类型,名称取的是fundName
      return version === 1 ? fundProductSimpleInfo?.fundName || '' : name;
    };

    return showList.map((item: TLooseObj) => ({
      // 产品名称
      ...item,
      title: productName(item),
      leatAmount: item.leatAmount.includes('起') ? item.leatAmount : `${item.leatAmount}起购`,
      price: item.price.replace(/ /g, ''),
      specification: item.specification.replace(/ /g, ''),
    }));
  };

  // 获取海报列表
  const getPosterList = async (pageNum: number) => {
    const { classification = '' } = state.posterParams;
    const { retdata = {} }: TLooseObj = await posterApi.getPosterList({
      pageNum,
      name: state.searchText,
      classSecondId: '',
      type: 1,
      pageSize: 18,
      classification,
    });
    let { total, list } = retdata;
    list = list.map((item: TLooseObj) => ({
      id: item.id,
      title: item.name,
      src: getImgUrl(item.url),
      desc: item.content,
      isRecommend: item.recommend,
    }));
    return { total, list };
  };
  // 获取活动列表
  const getActivityList = async (pageNum: number) => {
    const { categoryId = '', typeId = '' } = state.activityParams;
    // 活动列表查询
    const { retdata = {} }: TLooseObj = await bannerApi.getBannerList({
      pageNum,
      categoryId,
      name: state.searchText,
      typeId,
      pageSize: 10,
      urlFilter: false,
    });
    // console.log(res.retdata.total, res.retdata.list);
    let { total, list = [] } = retdata;
    list = list.map((item: TLooseObj) => ({
      id: item.bannerId,
      title: item.bannerName,
      dateTime: item.endTime ? `截止时间：${item.endTime}` : '',
      src: getImgUrl(item.bannerImgURL),
      isRecommend: item.isMainPush,
      endTime: item.endTime,
      startTime: item.startTime,
    }));
    return { total, list };
  };

  // 获取文章列表
  const getArticleList = async (pageNum: number) => {
    const { tags, queryType } = state.articleParams;
    const { retdata = {} }: TLooseObj = await newsApi.getNewsList({
      tags: tags || firstNavList.value[0]?.name,
      queryType: queryType || firstNavList.value[0]?.id,
      title: state.searchText,
      pageNum,
      pageSize: 15,
      orderType: 0,
    });
    let { total = 0, list = [] } = retdata;
    list = list.map((item: TLooseObj) => ({
      id: item.newsId,
      title: item.title,
      dateTime: item.publishTime ? `发布时间：${item.publishTime}` : '',
      src: getImgUrl(item.cover),
      isMust: item.mustSend,
      tags: item.tagList || [],
    }));
    return { total, list };
  };

  // 获取节点关怀列表
  const getCareList = async (pageNum: number) => {
    // 节点关怀查询参数selectedMarketItem
    const { retdata: careListRes }: TLooseObj = await taskApi.careSceneList({
      // 如果typeId为空,说明是页面初始查询,用一级导航第一项的id去查列表
      typeId: state.careParams.typeId || firstNavList.value[0].id,
      pageNum,
      pageSize: 10,
    });
    // console.log('getCareList',careListRes);

    let { total, content = [] } = careListRes;
    let list = content.map((item: TLooseObj) => ({
      // 为了方便取值,统一营销列表字段
      id: item.sourceId,
      title: item.name,
      desc: item.shareDescribe,
      src: getImgUrl(item.pic),
      isRecommend: item.isRecommend,
    }));

    return { total, list };
  };

  // 查询朋友圈列表
  const getMomentList = async (pageNum: number) => {
    const { sceneId, classifyId } = state.momentParams;

    const { retdata: momentsListRes }: TLooseObj = await taskApi.momentsList({
      pageNum,
      sceneId,
      classifyId,
      pageSize: 10,
    });

    let { total, content = [] } = momentsListRes;
    let list = content.map((item: TLooseObj) => {
      const { src, tags, article } = setMomentVal(item);
      return {
        // 为了方便取值,统一营销列表字段
        src,
        tags,
        article,
        id: item.momentId,
        title: item.advice,
        desc: item.momentText,
        dateTime: item.createTime ? `发布时间：${item.createTime}` : '',
      };
    });

    // console.log(momentsListRes);
    // console.log(total, list);
    return { total, list };
  };

  // 设置朋友圈神器文章与图片资源值
  const setMomentVal = (item: TLooseObj) => {
    let src = '';
    let tags = [];
    let article = {};
    const { resourceVO = {} } = item;
    const { type, imgs = [], newsResourceVOS = [], videoVO = {} } = resourceVO;
    // 海报
    if (type === 2) {
      src = imgs[0] || '';
    }
    // 文章类型
    else if (type === 3) {
      article = {
        title: newsResourceVOS?.[0]?.title,
        cover: newsResourceVOS?.[0]?.cover,
      };
      tags = newsResourceVOS?.[0]?.tags || [];
    }
    // 视频类型
    else if (type === 4) {
      src = videoVO.videCoverUrl || '';
    }
    return { src, tags, article };
  };

  // 获取节点关怀一级分类
  const getCareScene = async () => {
    const { retdata = [] } = await taskApi.careSceneTypeList({});
    // console.log(retdata);
    firstNavList.value = (retdata as TMarketItem[]).map((item: TMarketItem) => ({
      // 为了方便取值，统一营销类一级导航的列表字段
      id: item.typeId,
      name: item.name,
    }));
    queryMatchTypeList();
  };

  // 获取朋友圈一级导航分类列表
  const getMomentsScene = async () => {
    const { retdata = [] } = await taskApi.momentsScene({});
    firstNavList.value = (retdata as TMarketItem[]).map((item: TMarketItem) => ({
      // 为了方便取值，统一营销类一级导航的列表字段
      id: item.sceneId,
      name: item.name,
    }));

    // 一级导航切换时要同步更新二级导航
    getMomentsClassify();
  };

  // 获取朋友圈二级导航分类列表
  const getMomentsClassify = async (id?: number) => {
    // id为朋友圈神器一级导航分类id,如果id不为空,说明点击一级导航
    // 如果id为空,说明是页面初始查询, 默认用二级导航列表第一项的id去查询朋友圈神器列表
    state.momentParams.sceneId = id || firstNavList.value[0]?.id;

    const { sceneId } = state.momentParams;
    // 用一级导航id查询二级导航分类列表
    const { retdata: momentsClassify = [] }: TLooseObj = await taskApi.momentsClassify({ sceneId });
    secondNavList.value = momentsClassify.map((item: TMarketItem) => ({
      // 为了方便取值，统一营销类二级导航的列表字段
      id: item.classifyId,
      name: item.name,
    }));

    //  二级导航为空,不查询
    if (momentsClassify.length === 0) {
      return setEmptyPage();
    }
    // console.log(momentsClassify);
    // 一级导航切换时，默认用二级导航列表第一项的id去查询朋友圈神器列表
    state.momentParams.classifyId = secondNavList.value[0]?.id || '';
    queryMatchTypeList();
  };

  // 存在多图的情况
  const getImgUrl = (url = '') => {
    return url.includes(',') ? url.split(',')[0] : url;
  };

  // 二级导航为空时,免查询直接设置空页面
  const setEmptyPage = () => {
    state.loadEnd = true;
    marketSelectList.value = [];
  };

  //  切换底部操作区弹窗的显隐状态
  const toggleSelectedMarketVisible = (_visible?: boolean) => {
    if (enabledSelectedMarketList.value?.length) {
      state.visibleSelectMarketItem = true;
    } else {
      state.visibleSelectMarketItem = false;
    }
  };

  const removeAllSeclectItem = () => {
    Confirm({
      message: `是否清空当前选择的${MARKET_IFON[MARKET_TYPE[props.type]].text}？`,
      callback: () => {
        const _selectedMarketItems = state.selectedMarketItems.filter((item: any) => item.disabled);
        state.selectedMarketItems = _selectedMarketItems;
        toggleSelectedMarketVisible();
      },
    });
  };

  // 移除选中项
  const removeSelectedItem = (val: any) => {
    if (val?.disabled) {
      return;
    }
    const _newSelectedMarketItems = state.selectedMarketItems.filter((item: any) => item.id !== val?.id);
    state.selectedMarketItems = _newSelectedMarketItems;
    toggleSelectedMarketVisible();
  };

  // 重置查询参数
  const restQueryParams = () => {
    state.loadEnd = false;
    state.pager.pageNum = 1;
    marketSelectList.value = [];
  };

  /**
   * 让点击高亮的tab处于可视区
   * @param event tab点击事件源
   * @param className tab容器的样式类名
   */
  const fixedActiveTabVisual = (event: MouseEvent, className: string) => {
    const spanLeft = event.clientX; //当前点击的元素左边距离
    const totalWidths = document.body.clientWidth; //屏幕总宽度
    const widths = totalWidths / 2; //一半的屏幕宽度
    const spanRight = totalWidths - spanLeft; //元素的右边距离
    const scrollBox = document.querySelector(`.${className}`) as HTMLElement; //获取最外层的元素
    const scrollL = scrollBox.scrollLeft; //滚动条滚动的距离
    // console.log('fixedActiveTabVisual',scrollL);
    if (spanLeft > widths || spanRight > widths) {
      //当元素左边距离大于屏幕一半宽度  或者  右边距离大于屏幕一半距离的时候
      scrollBox.scrollLeft = scrollL + (spanLeft - widths); //滚动条最终的滚动距离
    }
  };

  // 只有选择产品需要上报埋点
  const setDataJTSender = (btnType: string) => {
    if (props.type !== MARKET_TYPE.SEND_PRODUCT) return '';
    const { id } = state.selectedMarketItems?.length && state.selectedMarketItems[0];
    const parameters = {
      objId: id,
      product_list: [id],
    };

    if (btnType === 'show-select') {
      return JSON.stringify({
        event_type: 'popup_window',
        block_desc: 'product_page',
        button_desc: 'enter_btn',
        parameters,
      });
    } else if (btnType === 'ensure') {
      return JSON.stringify({
        event_type: 'click',
        block_desc: 'product_page',
        button_desc: 'finish_btn',
        parameters,
      });
    }
  };

  // 点击确定按钮后,向父组件传递选择的参数
  const emit = defineEmits(['handleMarketTypeSelect']);
  const handleCheckedConfirm = () => {
    state.visibleSelectMarketItem = false;
    emit(
      'handleMarketTypeSelect',
      props.maxSeclectCount === 1 ? enabledSelectedMarketList.value[0] : enabledSelectedMarketList.value
    );
  };
</script>
<style lang="less" src="./market-list.less"></style>
